import { useSelector } from 'react-redux';
import { selectAllTeams } from '@shared/store/config.duck';
import { selectAllTags } from '@shared/store/userTags.duck';
import { selectWhereabouts } from '@features/whereabouts/pages/team-movements/models/team-movements.duck';
import { WhereaboutsScope } from '@features/whereabouts/models/whereaboutsScope';

// Heading for a scoped whereabouts page: the team name or workgroup label.
// Prefers the company-wide lists (available immediately) and falls back to the
// name carried on the loaded whereabouts. Undefined for the followed scope.
export function useScopeTitle(scope: WhereaboutsScope): string | undefined {
  const allTeams = useSelector(selectAllTeams);
  const allTags = useSelector(selectAllTags);
  const { teams, workgroups } = useSelector(selectWhereabouts);

  if (scope.kind === 'team') {
    const fromConfig = (allTeams ?? []).find(t => t.id === scope.teamId)?.name;
    const fromLoaded = teams.find(t => t.team?.id === scope.teamId)?.team?.name;
    return fromConfig || fromLoaded || undefined;
  }
  if (scope.kind === 'workgroup') {
    const fromTags = (allTags ?? []).find(t => t.id === scope.workGroupId)?.label;
    const fromLoaded = workgroups.find(w => w.tag?.id === scope.workGroupId)?.tag?.label;
    return fromTags || fromLoaded || undefined;
  }
  return undefined;
}
